module.exports = __webpack_public_path__ + "img/youth-driveway.72de4206.jpg";